"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var CartCard = /*#__PURE__*/function (_window$AbstractCard) {
    _inherits(CartCard, _window$AbstractCard);

    var _super = _createSuper(CartCard);

    _createClass(CartCard, null, [{
      key: "QUANTITY_UPDATE",
      get: function get() {
        return "cartcard_update";
      }
    }, {
      key: "PRODUCT_REMOVE",
      get: function get() {
        return "cartcard_remove";
      }
    }]);

    function CartCard(id, options) {
      var _this;

      _classCallCheck(this, CartCard);

      _this = _super.call(this, id, options);
      _this.$removeRef = _this.$domElement;
      _this.$quantity = _this.$domElement.find(".cart-card__quantity"); // exists only in cart-page

      _this.$plusBtn = _this.$domElement.find(".cart-card__plus-btn"); // exists only in cart-page

      _this.$minusBtn = _this.$domElement.find(".cart-card__minus-btn");
      _this.$trashBtn = _this.$domElement.find(".cart-card__trash-btn");
      _this.$removeBtn = _this.$domElement.find(".cart-card__remove-btn");
      _this.realQuantity = _this.currentQuantity;
      return _this;
    }

    _createClass(CartCard, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        console.log("%cINIT_MAX_QUANTITY: " + this.maxQuantity, "color: orangered;");
        this.evaluateQuantityButtons();
        /**
         *   Plus Button
         */

        this.$plusBtn.on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (_this2.currentQuantity == _this2.maxQuantity) {
            return;
          }

          _this2.currentQuantity = _this2.currentQuantity + 1;

          _this2.updateQuantity();

          _this2.evaluateQuantityButtons();
        });
        /**
         *   Minus Button
         */

        this.$minusBtn.on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (_this2.currentQuantity == 1) {
            return;
          }

          _this2.currentQuantity = _this2.currentQuantity - 1;

          _this2.updateQuantity();

          _this2.evaluateQuantityButtons();
        });
        this.$removeBtn.on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (!Globals.checkCookieBeforeUsingCart()) {
            return;
          }

          if (_this2.$domElement.hasClass("remove-state")) {
            _this2.removeProduct();
          }
        });
        this.$trashBtn.on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (!Globals.checkCookieBeforeUsingCart()) {
            return;
          }

          _this2.$domElement.toggleClass("remove-state");
        });

        _get(_getPrototypeOf(CartCard.prototype), "init", this).call(this);
      }
    }, {
      key: "evaluateQuantityButtons",
      value: function evaluateQuantityButtons() {
        // PLUS
        this.$plusBtn.attr('disabled', !this.maxQuantity || this.currentQuantity == this.maxQuantity); // MINUS

        this.$minusBtn.attr('disabled', !this.maxQuantity || this.currentQuantity == 1);
      }
    }, {
      key: "enable",
      value: function enable() {
        this.$domElement.css({
          "pointer-events": "auto",
          "opacity": 1
        });
        this.$trashBtn.prop("disabled", false);
        this.$removeBtn.prop("disabled", false);
      }
    }, {
      key: "disable",
      value: function disable() {
        var opacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
        this.$domElement.css({
          "pointer-events": "none",
          "opacity": opacity
        });
        this.$trashBtn.prop("disabled", true);
        this.$removeBtn.prop("disabled", true);
      }
    }, {
      key: "updateQuantity",
      value: function updateQuantity() {
        this._killAJAXRequest();

        if (!Globals.checkCookieBeforeUsingCart()) {
          return;
        }

        if (this.$domElement.data("onlyone") == "true" || this.maxQuantity == 1) {
          alert(Globals.CAN_ONLY_BUY_ONE);
          this.currentQuantity = 1;
          return;
        } else {
          if (this.currentQuantity > this.maxQuantity) {
            alert(Globals.REQUESTED_QUANTITY_IS_NOT_AVAILABLE.replace("$requested", this.currentQuantity).replace("$available", this.maxQuantity));
            this.currentQuantity = this.maxQuantity;
            return;
          }
        }

        this.disable();
        this.AJAXrequest = $.ajax({
          dataType: "json",
          type: "POST",
          url: window.Globals.CART_CHANGE_URL,
          data: {
            id: this.$domElement.data("variant-id"),
            quantity: this.currentQuantity
          },
          success: this.updateQuantityDone.bind(this),
          error: this.updateQuantityFail.bind(this)
        });
      }
    }, {
      key: "_killAJAXRequest",
      value: function _killAJAXRequest() {
        if (this.AJAXrequest) {
          this.AJAXrequest.abort();
          this.AJAXrequest = null;
        }
      }
    }, {
      key: "updateQuantityDone",
      value: function updateQuantityDone(response) {
        console.log("--------------- RESPONSE ---------------");
        console.log(response);
        var updatedQuantity;

        for (var i = 0; i < response.items.length; i++) {
          if (this.$domElement.data("variant-id") === response.items[i].variant_id) {
            updatedQuantity = response.items[i].quantity;
            break;
          }
        }

        if (updatedQuantity != this.currentQuantity) {
          alert(Globals.REQUESTED_QUANTITY_IS_NOT_AVAILABLE.replace("$requested", this.currentQuantity).replace("$available", parseInt(this.$domElement.data("max-quantity"))));
          this.$domElement.data("max-quantity", "");
          this.currentQuantity = updatedQuantity;
        }

        this.realQuantity = this.currentQuantity;
        this.$domElement.trigger(CartPage.CART_CHANGE_SUCCESS, [response]);
        this.enable();
        this.evaluateQuantityButtons();
      }
    }, {
      key: "updateQuantityFail",
      value: function updateQuantityFail(response) {
        console.log("Update Quantity Fail -> FAIL", response);
        this.$domElement.trigger(CartPage.CART_CHANGE_ERROR, [response]);
        this.evaluateQuantityButtons();
      }
    }, {
      key: "removeProduct",
      value: function removeProduct() {
        this._killAJAXRequest();

        if (!Globals.checkCookieBeforeUsingCart()) {
          return;
        }

        this.disable(1);
        this.pushRemoveFromCartDataLayer();
        this.AJAXrequest = $.ajax({
          dataType: "json",
          type: "POST",
          url: window.Globals.CART_CHANGE_URL,
          data: {
            id: this.$domElement.data("variant-id"),
            quantity: 0
          },
          success: this.removedFromCartDone.bind(this),
          error: this.removedFromCartFail.bind(this)
        });
      }
    }, {
      key: "pushRemoveFromCartDataLayer",
      value: function pushRemoveFromCartDataLayer() {
        console.log('------> pushRemoveFromCartDataLayer');
        console.log('v_id', this.$domElement.data("variant-id")); // console.log('CART_ITEMS', Globals.CART_ITEMS);

        var ttttt = _.findWhere(Globals.CART_ITEMS, {
          item_variant: this.$domElement.data("variant-id").toString()
        }); // console.log('ttttt', ttttt);

        /* console.log('dataLayerPush', {
          event: "remove_from_cart",
          ecommerce: {
            items: [ttttt]
          }
        }); */


        dataLayer.push({
          ecommerce: null
        });
        dataLayer.push({
          event: "remove_from_cart",
          ecommerce: {
            items: [ttttt]
          }
        });
      }
    }, {
      key: "removedFromCartDone",
      value: function removedFromCartDone(response) {
        var _this3 = this;

        /*
            NB: autoInstance is active we just need to remove the DOM element
        */
        this.$domElement.parent().css({
          overflow: "hidden",
          position: "relative",
          top: 0,
          left: 0,
          boxSizing: "content-box",
          height: this.$domElement.outerHeight()
        });
        this.$domElement.css({
          pointerEvents: "none",
          position: "absolute",
          top: this.$domElement.parent().css("padding-top"),
          left: this.$domElement.parent().css("padding-left"),
          width: this.$domElement.parent().innerWidth()
        });
        window.TweenMax.to(this.$domElement.parent(), 0.5, {
          force3D: "auto",
          paddingTop: 0,
          paddingBottom: 0,
          height: 0,
          ease: window.Cubic.easeOut,
          onComplete: function onComplete() {
            _this3.$domElement.trigger(CartPage.CART_CHANGE_SUCCESS, [response]);

            _this3.$domElement.remove();
          }
        });
      }
    }, {
      key: "removedFromCartFail",
      value: function removedFromCartFail(response) {
        this.$domElement.trigger(CartPage.CART_CHANGE_ERROR, [response]);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this._killAJAXRequest();

        if (this.$plusBtn) this.$plusBtn.off("click");
        if (this.$minusBtn) this.$minusBtn.off("click");
        if (this.$removeBtn) this.$removeBtn.off("click");
        this.$trashBtn.off("click");

        _get(_getPrototypeOf(CartCard.prototype), "dispose", this).call(this);
      }
    }, {
      key: "maxQuantity",
      get: function get() {
        return parseInt(this.$domElement.attr("data-max-quantity"));
      },
      set: function set(value) {
        this.$domElement.attr("data-max-quantity", value.toString());
      }
    }, {
      key: "currentQuantity",
      get: function get() {
        return parseInt(this.$quantity.attr("data-quantity"));
      },
      set: function set(value) {
        this.$quantity.attr("data-quantity", value.toString());
      }
    }]);

    return CartCard;
  }(window.AbstractCard);

  window.CartCard = CartCard;
})(window);
